import { render, staticRenderFns } from "./founder-introduction.vue?vue&type=template&id=7fd0642e&scoped=true&"
import script from "./founder-introduction.vue?vue&type=script&lang=js&"
export * from "./founder-introduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd0642e",
  null
  
)

export default component.exports